// extracted by mini-css-extract-plugin
export var mt0 = "widget-form-module--mt-0--e531d";
export var mt1 = "widget-form-module--mt-1--30d8e";
export var mt2 = "widget-form-module--mt-2--3fcba";
export var mt3 = "widget-form-module--mt-3--863d1";
export var mt4 = "widget-form-module--mt-4--b7aed";
export var mt5 = "widget-form-module--mt-5--d2aed";
export var mt6 = "widget-form-module--mt-6--eb10d";
export var widgetForm = "widget-form-module--widget-form--c4eb2";
export var widgetForm__body = "widget-form-module--widget-form__body--13844";
export var widgetForm__form = "widget-form-module--widget-form__form--87d88";
export var widgetForm__headline = "widget-form-module--widget-form__headline--3c7b7";
export var widgetForm__img = "widget-form-module--widget-form__img--462d9";